import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { DeleteModal } from "components/common/DeleteModal/DeleteModal";
import { DeleteIcon } from "components/common/Icons/DeleteIcon";
import { SmallContainer } from "components/common/SmallContainer/SmallContainer";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { useDeleteAll } from "./useDeleteAll";

export const DeleteAll = () => {
    const { isOpen, open, close, handleDeleteAll } = useDeleteAll();

    return (
        <>
            <ToolTip text={capitalize(translateFunc("delete-all"))}>
                <SmallContainer
                    className={`group cursor-pointer py-2 px-3 border border-irGray-400 dark:border-darkSurface-100
                    rounded-lg grid items-center hover:bg-irRed-400 dark:hover:bg-darkSurface-200 ${
                        isOpen ? "bg-gray-200 dark:bg-darkSurface-200": "dark:bg-darkSurface-300"
                    }`}
                    onClick={open}
                    data-testid={`delete-all-modal-opener`}
                >
                    <div className="group-hover:hidden">
                        <DeleteIcon fill="black" />
                    </div>
                    <div className="hidden group-hover:block">
                        <DeleteIcon fill="white" />
                    </div>
                </SmallContainer>
            </ToolTip>
            <DeleteModal handleDelete={handleDeleteAll} isOpen={isOpen} close={close} />
        </>
    );
};
